// The landing page's pictures: trynaru.com's own (made by Miki for Naru) and the Hoops art from Miki's demo, served
// from this site's files. Their descriptions are messages.
import arena from './pictures/landing-arena.webp';
import bananaPeel from './pictures/landing-banana-peel.webp';
import basketballQuestion from './pictures/landing-basketball-question.webp';
import coachSam from './pictures/landing-coach-sam.webp';
import family from './pictures/landing-family.webp';
import heroTall from './pictures/landing-hero-tall.webp';
import heroWide from './pictures/landing-hero-wide.webp';
import stepOne from './pictures/landing-step-1.webp';
import stepTwo from './pictures/landing-step-2.webp';
import stepThree from './pictures/landing-step-3.webp';

export const LANDING_PICTURES = {
  heroWide,
  heroTall,
  basketballQuestion,
  bananaPeel,
  arena,
  coachSam,
  family,
  steps: [stepOne, stepTwo, stepThree]
};
